<template>
<div :style="{'height':height, 'width':width}">
    <label v-if="label!==null">
        {{ label }}
        <span style="color:red">
            {{ required ? '*' : '' }}
        </span>
    </label>
    <div class="input-group" >
        <div class="input-group-prepend" v-if="showCountryCodeSelector">
            <button v-if="activeCountryCode !== null"
                class="btn btn-xs btn-outline-secondary dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                :disabled="!enableCountryCodeSelector||disabled||!enableComponent"
            >
            <img :src="activeCountryCode.flag" height="25" width="25"> +{{ activeCountryCode.code }}
            </button>
            <div class="dropdown-menu">
                <a v-for="(ccode, index) in countryCodes" class="dropdown-item" href="" @click.prevent="activeCountryCode = ccode" :key="`flag-${index}`">
                    <img :src="ccode.flag" height="25" width="25"> +{{ ccode.code }}
                </a>
            </div>
        </div>
        <input
            type="tel"
            inputmode="numeric" 
            pattern="[0-9]*"
            v-mask="mask"
            class="form-control"
            :class="[{'is-invalid': !isValid}]"
            :placeholder="placeholder"
            v-model="input"
            :maxlength="14"
            :required="required"
            :disabled="disabled || !enableComponent"
            :readonly="readOnly"
            @click="onClick"
            @change="onChange"
            @focus="onFocus"
            @blur="onBlur"
            @keyup="onKeyPress"
            @keypress.enter.prevent="onKeyPressEnter"
            @keydown.tab="onKeyDownTab"
            :autocomplete="autocomplete"
        >
    </div>
    <div class="invalid-feedback" style="display:block !important" v-for="(error, index) of errors" :key="`error-${index}`">{{ error }}</div>
</div>
</template>
    
<script>
import Vue from 'vue'
import phoneFormat from '../../../mixins/phoneFormat';
import checkPermissions from '../../../mixins/checkPermissions';
import {mask} from 'vue-the-mask'
Vue.directive('mask', mask);
export default {
    name:'input-phone',
    mixins: [phoneFormat, checkPermissions],
    props:{
        dataSource:                 {type: String,  default: null},
        value:                      {},
        defaultValue:               {},
        height:                     {type: String, default: "100%"},
        width:                      {type: String, default: "100%"},
        label:                      {type: String, default: null},
        required:                   {type: Boolean, default: false},
        disabled:                   {type: Boolean, default: false},
        placeholder:                {type: String, default:"(123) 456-7890"},
        countryCode:                {type:String, default: '1'},
        showCountryCodeSelector:    {type: Boolean, default: true},
        enableCountryCodeSelector:  {type: Boolean, default: true},
        autocomplete:               {type: String, default: "new-password"},
        readOnly:                   {type: Boolean, default: false},
        
    },
    watch:{
        value(val){
            this.input = val;
        },
        input(){
            this.$emit('input', this.input);
        }
    },
    computed:{
        isValid(){
            return this.errors.length == 0;
        },
        inputType() {
            return this.$parent.type;
        },
        input: {
            get() {
                if (this.dataSource == null) return this.l_input ? this.phoneFormat(this.l_input) : this.l_input;
                if (this.inputType === 'list') {
                    let val = this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource];
                    return val ? this.phoneFormat(val) : val;
                } else {
                    let val = this.$parent.data_provider_ref[this.inputType][this.dataSource];
                    return val ? this.phoneFormat(val) : val;
                }
            },
            set(newval) {
                let aux = this.unmask(newval);
                //for do: We're going to store the country code in a separate field.
                if (aux && aux.length == 10) {
                    aux = `${this.activeCountryCode ? this.activeCountryCode.code : "1"}${aux}`
                }
                if (this.dataSource) {
                    if (this.inputType === 'list') {
                        this.$set(this.$parent.data_provider_ref[this.inputType][this.index], this.dataSource, aux);
                    } else {
                        this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, aux);
                    }
                } else {
                    this.l_input = aux;
                }
            }
        }
    },

    methods:{
        validate_input(){
            this.errors = [];
            if (this.required) {
                if (!this.input || `${this.input}`.length == 0) {
                    this.errors.push('This Field is Required');
                    return false
                }
            }
            if(this.input.length < 10 ){
                this.errors.push('Invalid Phone');
                return false
            }
            return true;
        },
        unmask(maskedValue) {
            if (this.mask !== null) {
                let defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/;
                return maskedValue ? maskedValue.replace(new RegExp(defaultDelimiters, 'g'), '') : maskedValue;
            } else {
                return typeof maskedValue === 'string' ? (maskedValue.length > 0 ? maskedValue : null) : maskedValue;
            }
        },
        onKeyPress()        { this.$emit('onKeyPress', this); },
        onKeyPressEnter()   { this.$emit('onKeyPressEnter', this); },
        onKeyDownTab()      { this.$emit('onKeyDownTab', this); },
        onBlur()            { this.$emit('onBlur', this); },
        onFocus()           { this.$emit('onFocus', this); },
        onClick()           { this.$emit('onClick', this); },
        onChange()          { this.$emit('onChange', this); },
    },
    mounted() {
        this.activeCountryCode = this.countryCodes[0];
        if (typeof this.value !== 'undefined') this.input = this.value;
        else if (typeof this.defaultValue !== 'undefined') this.input = this.defaultValue;
        if (this.dataSource !== null) this.$parent.data_provider_ref.inputs[this.dataSource] = this; 
        this.$emit('onMounted', this);
    },
    data(){
        return{
            mask:"(###) ###-####",
            errors:[],
            countryCodes: [
                {
                    code: "1",
                    flag: "https://icons.iconarchive.com/icons/wikipedia/flags/1024/US-United-States-Flag-icon.png",
                    country: "eeuu"
                }
            ],
            activeCountryCode: null,
            l_input: null
        }
    }
}
</script>